import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
import { FormControl } from '@angular/forms';
/**
 * 単行テキスト入力フィールド
 *【内容:content:string】
 *【プレースホルダ:placeholder:string】
 *【表示条件:visible:boolean】
 *【ラベル内容:labelContent:string】
 *【非活性:disabled:boolean】
 *【フォームコントロール名:formControl:FormControl】
 *【配置:textAlign:string】
 *【ボタン配置:shouldShowButton:boolean】
 *【ボタン名:inputButton:string】
 *【表示桁数:displayBytes:number】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-single-line-input-field',
  templateUrl: './single-line-input-field.html',
  styles: [`
    app-single-line-input-field {
      .text-right {
        input {
            text-align : right;
        }
      }
    }
  `]
})
export class SingleLineInputField extends BaseWidget {
  /**
   * 内容の表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 内容に対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * 内容
   */
  @Input() content:string

  /**
   * プレースホルダ
   */
  @Input() placeholder:string

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * ラベル内容
   */
  @Input() labelContent:string

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * フォームコントロール名
   */
  @Input() formControl:FormControl

  /**
   * 配置
   */
  @Input() textAlign:string

  /**
   * ボタン配置
   */
  @Input() shouldShowButton:boolean

  /**
   * ボタン名
   */
  @Input() inputButton:string

  /**
   * 表示桁数
   */
  @Input() displayBytes:number

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  updateValue(event) {
    const value = event
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => event,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    if (this.content !== value) {
      this.on("change");
    }
  }
  clearValue(event) {
    const value = "";
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    if (this.content !== value) {
      this.on("change");
    }
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/form/single-line-input-field/single-line-input-field.component.ts